<template>
    <div>
        <v-row justify="center">
            <v-dialog v-model="dialog" persistent="" scrollable  max-width="600px">
                <v-card>
                    <v-card-title id="add_user_dialog_card_title">{{ formTitle }}</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text style="height: auto;">
                        <div style="min-height:10px;"></div>
                        <br>
                        <form-validation-messages :messages="apiValidationMessages"></form-validation-messages>
                        <form-submit-messages :messages="apiMessages" :errorMessages="apiErrorMessages"></form-submit-messages>
                        <v-container grid-list-md>
                             <v-layout row wrap>
                                <!-- plačnik --> 
                                <v-flex xs12 sm12 md6 lg6>
                                    <v-icon left>mdi-clipboard-account</v-icon><span>Plačnik</span>
                                </v-flex>
                                <v-flex xs12 sm12 md6 lg6>
                                    <span class="font-weight-bold">{{ (item !== null && item.payer !== null) ? item.payer.name : "" }}</span>
                                </v-flex>

                                <!-- član -->
                                <v-flex xs12 sm12 md6 lg6>
                                    <v-icon left>mdi-clipboard-account</v-icon><span>Član</span>
                                </v-flex>
                                <v-flex xs12 sm12 md6 lg6>
                                    <span class="font-weight-bold">{{ (item !== null && item.member !== null) ? item.member.name : "" }}</span>
                                </v-flex>

                                <!-- tip člana -->
                                <v-flex xs12 sm12 md6 lg6>
                                    <v-icon left>mdi-bookmark</v-icon><span>Tip člana</span>
                                </v-flex>
                                <v-flex xs12 sm12 md6 lg6>
                                    <span class="font-weight-bold">{{ (item !== null && item.member !== null && item.member.member_type !== null) ? item.member.member_type.name : "" }}</span>
                                </v-flex>

                                <!-- članarina -->
                                <v-flex xs12 sm12 md6 lg6>
                                    <v-icon left>mdi-bookmark</v-icon><span>Članarina</span>
                                </v-flex>
                                <v-flex xs12 sm12 md6 lg6>
                                    <span class="font-weight-bold">{{ (item !== null && item.member.membership_fee !== null) ? item.member.membership_fee.name : "" }}</span>
                                </v-flex>

                                <!-- leto --> 
                                <v-flex xs12 sm12 md6 lg6>
                                    <v-icon left>mdi-calendar-range</v-icon><span>Leto</span>
                                </v-flex>
                                <v-flex xs12 sm12 md6 lg6>
                                    <span class="font-weight-bold">{{ (item !== null) ? item.membership_fee_year : "" }}</span>
                                </v-flex>

                                <!-- znesek -->
                                <v-flex xs12 sm12 md6 lg6>
                                    <v-icon left>mdi-cash-multiple</v-icon><span>Znesek</span>
                                </v-flex>
                                <v-flex xs12 sm12 md6 lg6>
                                    <span class="font-weight-bold">{{ (item !== null) ? item.amount + " €" : "" }}</span>
                                </v-flex>

                                <!-- operater -->
                                <v-flex xs12 sm12 md6 lg6>
                                    <v-icon left>mdi-account-circle</v-icon><span>Operater</span>
                                </v-flex>
                                <v-flex xs12 sm12 md6 lg6>
                                    <span class="font-weight-bold">{{ (item !== null) ? item.app_user : "" }}</span>
                                </v-flex>

                                <!-- datum in čas plačila -->
                                <v-flex xs12 sm12 md6 lg6>
                                    <v-icon left>mdi-calendar-clock</v-icon><span>Datum in čas plačila</span>
                                </v-flex>
                                <v-flex xs12 sm12 md6 lg6>
                                    <span class="font-weight-bold">{{  (item !== null) ? item.created_at_formatted : "" }}</span>
                                </v-flex>

                                <!-- številka plačila (potrdila payment id) -->
                                <v-flex xs12 sm12 md6 lg6>
                                    <v-icon left>mdi-numeric</v-icon><span>ID plačila</span>
                                </v-flex>
                                <v-flex xs12 sm12 md6 lg6>
                                    <span class="font-weight-bold">{{ (item !== null ) ? item.membership_fee_payment_id : "" }}</span>
                                </v-flex>
                             </v-layout>
                             
                        </v-container>


                        <!-- podatki o članu -->
                        <!-- podatki o članarini -->
                        <!-- podatki o plačilu -->
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-text v-if="$vuetify.breakpoint.xsOnly">
                        &nbsp;
                            <v-btn style="" :loading="loadingPrint" :disabled="loading ||loadingPrint"  block outlined v-if="paymentId !== null && paymentId !=''" color="success"   @click="printPaymentReceipt()"><v-icon left>mdi-printer</v-icon>Natisni potrdilo</v-btn>&nbsp;
                            <v-btn style="" block outlined color="error"   @click="cancel()"><v-icon left>mdi-close</v-icon>{{ cancelText }}</v-btn>
                    </v-card-text>
                    <v-card-actions v-else>
                        <v-btn v-if="paymentId !== null && paymentId !=''" :loading="loadingPrint" :disabled="loading ||loadingPrint" color="success" text  @click="printPaymentReceipt()"><v-icon left>mdi-printer</v-icon>Natisni potrdilo</v-btn>
                        <v-btn color="error" text  @click="cancel()"><v-icon left>mdi-close</v-icon>{{ cancelText }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import { formatDate, randomPinNumber, getCurrentDate } from '@/helpers/utilities.js'
import { devicePlatform, rawBtPrint } from '@/helpers/services.js'
import { EventBus } from '@/main.js'
const FormValidationMessages = () => import('@/components/FormValidationMessages.vue')
const FormSubmitMessages = () => import('@/components/FormSubmitMessages.vue')

export default {
    name: 'membership-fee-payment-details-dialog',

    components: {
        FormValidationMessages,
        FormSubmitMessages
    },

    data: () => ({
        valid: true,
        formTitle: "",
        cancelText: "Zapri",
        dialog: false,
        item: null,
        loading: false, 
        loadingPrint: false,
        
        currentDate: null,

        card1: true,
        card2: true,
        card3: true,
        catd4: true,

        id: null,
        membership_fee_id: null,
        membership_fee: null,
        payment_date: null,
        year_for_payment: null,
        invoice_id: null,
        invoice: null,
        amount: null,
        amount_formatted: null,
        payment_date_formatted: null,
        payer_id: null,
        payer: null,
        member_id: null,
        member: null,
        active: null,
        note: null,
        uuid: null,
        created_at_formatted: null,
        updated_at_formatted: null,

        member_name: null,
        member_address: null,
        member_house_number: null,
        member_houser_umber_addon: null,
        member_postcode_id: null,
        member_town: null,
        member_phone_number: null,
        member_email: null,
        member_tax_number: null,
        member_member_type_id: null,
        member_member_classification_id: null,
        member_date_of_registration: null,
        member_date_of_withdrawal: null,
        member_date_of_death: null,
        member_withdrawal_type_id: null,
        member_note: null,

        payer_name: null,
        payer_address: null,
        payer_house_number: null,
        payer_houser_umber_addon: null,
        payer_postcode_id: null,
        payer_town: null,
        payer_phone_number: null,
        payer_email: null,
        payer_tax_number: null,
        payer_member_type_id: null,
        payer_member_classification_id: null,
        payer_date_of_registration: null,
        payer_date_of_withdrawal: null,
        payer_date_of_death: null,
        payer_withdrawal_type_id: null,
        payer_note: null,

        postcodes: [],
        gender: [],
        memberTypes: [],
        memberClassifications: [],
        withdrawalTypes: [],
        years: [],
        backendMessages: [],
        backendErrorMessages: [],
        backendValidationMessages:[]

    }),

    watch: {

    },

    computed: {
         apiMessages() {
            return this.backendMessages;
        },

        apiErrorMessages() {
            return this.backendErrorMessages 
        },

        apiValidationMessages() {
            return this.backendValidationMessages
        },

        paymentId() {
            if(this.item != null) {
                return this.item.membership_fee_payment_id
            }

            return null
        }
    },

    methods: {
        cancel() {
            this.dialog = false
        },

        setFormTitle(item) {
            this.formTitle = "Plačilo članarine št. #" + this.item.id
        },

        setPayerData(payer) {
            if(payer !== null && payer !== undefined) {
                this.payer_name = payer.name
                this.payer_address = payer.address
                this.payer_house_number = payer.house_number
                this.payer_house_number_addon = payer.house_number_addon
                this.payer_postcode_id = payer.postcode_id,
                this.payer_town = payer.town
                this.payer_gender_id = payer.gender_id
                this.payer_phone_number = payer.phone_number
                this.payer_email = payer.email
                this.payer_tax_number= payer.tax_number
                this.payer_member_type_id = payer.member_type_id
                this.payer_member_classification_id = payer.member_classification_id
                this.payer_date_of_registration = payer.date_of_registration
                this.payer_date_of_withdrawal = payer.date_of_withdrawal
                this.payer_date_of_death = payer.date_of_death
                this.payer_withdrawal_type_id = payer.withdrawal_type_id
                this.payer_note = payer.note
            }   
        },

        setMemberData(member) {
            if(member !== null && member !== undefined) {
                this.member_name = member.name
                this.member_address = member.address
                this.member_house_number = member.house_number
                this.member_house_number_addon = member.house_number_addon
                this.member_postcode_id = member.postcode_id,
                this.member_town = member.town
                this.member_gender_id = member.gender_id
                this.member_phone_number = member.phone_number
                this.member_email = member.email
                this.member_tax_number= member.tax_number
                this.member_member_type_id = member.member_type_id
                this.member_member_classification_id = member.member_classification_id
                this.member_date_of_registration = member.date_of_registration
                this.member_date_of_withdrawal = member.date_of_withdrawal
                this.member_date_of_death = member.date_of_death
                this.member_withdrawal_type_id = member.withdrawal_type_id
                this.member_note = member.note
            }
        },

        setData(item) {
            if(item !== null) {
                this.id = item.id
                this.membership_fee_id = item.membership_fee_id
                this.membership_fee = item.membership_fee
                this.payment_date = item.payment_date
                this.payment_date_formatted = item.payment_date_formatted
                this.year_for_payment = item.year_for_payment
                this.invoice_id = item.invoice_id
                this.invoice = item.invoice
                this.amount = item.amount
                this.amount_formatted = item.amount_formatted
                this.payer_id = item.payer_id
                this.payer = item.payer
                this.member_id = item.member_id
                this.member = item.member
                this.active = item.active
                this.note = item.note
                this.uuid = item.uuid
                this.created_at_formatted = item.created_at_formatted
                this.updated_at_formatted = item.updated_at_formatted
            }
        },

        printPaymentReceipt() {
            let vm = this;
            vm.loadingPrint = true
            vm.backendValidationMessages = []
            vm.backendMessages = []
            vm.backendErrorMessages = []

            let printData = {
                payment_id: this.paymentId,
                device_platform: devicePlatform()
            }


            vm.$store.dispatch('MEMBERSHIP_FEE_PAYMENT_PRINT', printData)
            //vm.$store.dispatch('TEST_PRINT')
            .then(response => {
                window.console.log(response)
                window.console.log(response.data.data)
                vm.backendMessages.push('Tisk potrdila je v teku ....');
                vm.disablePaymentBtn = true
                vm.cancelText = "Zaključi"
                vm.paymentDone = true;
                let rawBtContent = response.data.data

                if(rawBtContent !== "error" && rawBtContent !== null) {
                    //window.location.href = rawBtContent
                    //vm.rawBtPrint(rawBtContent)
                    rawBtPrint(rawBtContent)
                    window.console.log("print...")
                    window.console.log(rawBtContent)

                    vm.timeout1 = setTimeout(() => {
                        vm.backendValidationMessages = []
                        vm.backendMessages = []
                        vm.backendErrorMessages = []
                    }, 6000)
                    
                } else
                {
                    vm.backendErrorMessages.push('Ups... pri tiskanju potrdila o plačilu članarine je do napake. Poskusite ponovno.')
                }

            })
            .catch(error => {
                console.log('CREATE_MEMBERSHIP_FEE_PAYMENT error')
                console.log(error)

                if(error.response.status === 422) {
                    window.console.log(error.response.data.errors)
                    for (const property in error.response.data.errors) {
                        //window.console.log(`${property}: ${error.response.data.errors[property]}`);
                        var propertyData = error.response.data.errors[property];
                        //window.console.log(propertyData);
                        propertyData.forEach(message => {
                            vm.backendValidationMessages.push(message);
                        })
                    }
                } else {
                    vm.backendErrorMessages.push('Ups... pri zapisovanju plačila je prišlo do napake. Poskusite ponovno.')
                }

            })
            .finally(() => {
                setTimeout(() =>{
                    vm.loadingPrint = false
                },2000)
            })
        }
    },

    created() {
        var vm = this;
        this.currentDate = getCurrentDate()

        vm.$store.commit('SET_PROGRESS', true)
        vm.$store.dispatch('PARAMETERS_DATA')
        .then(response => {
            // window.console.log(response.data)
            vm.gender = response.data.gender
            vm.postcodes = response.data.postcodes
            vm.memberTypes = response.data.memberTypes
            vm.memberClassifications = response.data.memberClassifications
            vm.withdrawalTypes = response.data.withdrawalTypes
            vm.years = response.data.years
        })
        .catch(error => {
            window.console.error("### ERROR Users.vue@mounted ###");
            window.console.error(error)
        })
        .finally(() => {
            vm.$store.commit('SET_PROGRESS', false)
        })

        EventBus.$on('MEMBERSHIP_FEE_PAYMENTS_DETAILS_DIALOG', (data) => {
            console.log(data)
            vm.item = data
            vm.setData(data)
            vm.setPayerData(vm.payer)
            vm.setMemberData(vm.member)
            vm.setFormTitle(data)
            vm.dialog = true
        })
    },

    mounted() {

    },

    beforeDestroy() {

    },

    destroyed() {
        EventBus.$off('MEMBERSHIP_FEE_PAYMENTS_DETAILS_DIALOG')
    }



}


</script>

<style scoped>
    #add_user_dialog_card_title {
        background-color: #F5F5F5;
    }
</style>